class Timeout {
    static seconds(seconds) {
        return {then: callback => new Timeout(callback, seconds * 1000)};
    }

    constructor(callback, duration) {
        this.timeout = window.setTimeout(callback, duration);
    }

    clear() {
        window.clearTimeout(this.timeout);
    }
}

export default Timeout;